import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children?: React.ReactNode;
  width?: string | number;
  footer?: React.ReactNode;
}

export const GenericModal: React.FC<ModalProps> = ({
  open,
  onClose,
  title,
  children,
  width,
  footer,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth={width ? false : 'md'}
    fullWidth={!width}
    PaperProps={{
      style: {
        borderRadius: '16px',
        padding: '10px',
        width: width || undefined,
        maxWidth: width || undefined,
        maxHeight: '90vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
      },
    }}>
    {title && (
      <DialogTitle sx={{ padding: 0, flexShrink: 0 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" p={2}>
          <Typography variant="h6" component="h2" sx={{ fontSize: 22, fontWeight: 600 }}>
            {title}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
    )}
    <DialogContent
      sx={{
        flex: '1 1 auto',
        overflowY: 'auto',
        minHeight: 0,
      }}>
      {children}
    </DialogContent>
    {footer ? (
      <Box
        sx={{
          flexShrink: 0,
          px: 3,
          pb: 2,
          pt: 2,
          borderTop: 1,
          borderColor: 'divider',
        }}>
        {footer}
      </Box>
    ) : null}
  </Dialog>
);
